import { AttachMoney, House, LaptopMac, Wifi } from "@mui/icons-material";
import { Box, Grid, Link, Paper, Tooltip, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";

import { createSpotSlug } from "../../../common/utils/utils";
import { selectSpot } from "../spotsSlice";

import { lifeCostLabels } from "./formComponents/LifeCost";
import { wifiLabels } from "./formComponents/WifiRating";
import LikeSpotButton from "./LikeSpotButton";
import SurfSeasonBadge from "./SurfSeasonBadge";

function SpotCard({ id }) {
  // const dispatch = useDispatch();

  const spot = useSelector((state) => selectSpot(state, id));

  // Defensive programming - handle loading state
  if (!spot) {
    return (
      <Grid item container>
        <Paper
          sx={{
            display: "flex",
            minHeight: 200,
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography color="text.secondary">Loading spot...</Typography>
        </Paper>
      </Grid>
    );
  }

  const spotUrl = `/destination/${createSpotSlug(spot.name, spot.country, spot.id)}`;

  return (
    <Grid item container sx={{ position: "relative" }}>
      <Link
        component={RouterLink}
        to={spotUrl}
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
        }}
        aria-label={spot.name}
      />
      <Paper
        sx={{
          backgroundSize: "cover", // Adjust the size of the background image
          backgroundPosition: "center", // Center the background image
          backgroundRepeat: "no-repeat",
          backgroundImage: `url(${spot.image_link})`,
          display: "flex",
          minHeight: 200,
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            width: "100%",
            p: 2,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", position: "relative", zIndex: 1 }}>
              <Tooltip
                title={
                  spot.hasCoworking
                    ? "Coworking space available."
                    : "No coworking space."
                }
              >
                <Box
                  sx={{
                    p: 1,
                    borderRadius: 1.5,
                    bgcolor: "secondary.main",
                    m: 0.5,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <LaptopMac
                    fontSize="small"
                    color={spot.hasCoworking ? "primary" : "disabled"}
                  />
                </Box>
              </Tooltip>
              <Tooltip
                title={spot.hasColiving ? "Coliving available." : "No coliving."}
              >
                <Box
                  sx={{
                    borderRadius: 1.5,
                    p: 1,
                    bgcolor: "secondary.main",
                    m: 0.5,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <House
                    fontSize="small"
                    color={spot.hasColiving ? "primary" : "disabled"}
                  />
                </Box>
              </Tooltip>
            </Box>
            <Box sx={{ position: "relative", zIndex: 1 }}>
              <LikeSpotButton id={id} />
            </Box>
          </Box>
          <Box sx={{ position: "relative", zIndex: 1 }}>
            <SurfSeasonBadge surfSeason={spot.surfSeason} />
          </Box>
        </Box>
      </Paper>
      <Grid item container p={0.5} marginBottom={1} alignContent={"flex-start"} sx={{ position: "relative", zIndex: 1 }}>
        <Tooltip title={`Wifi quality: ${wifiLabels[spot.wifiQuality]}`}>
          <Grid item xs={6}>
            {[...Array(5)].map((_, index) => {
              return (
                <Wifi
                  key={index}
                  sx={{ fontSize: 17 }}
                  color={index < spot.wifiQuality ? "primary" : "disabled"}
                ></Wifi>
              );
            })}
          </Grid>
        </Tooltip>
        <Tooltip title={`Life cost: ${lifeCostLabels[spot.lifeCost]}`}>
          <Grid item container xs={6} justifyContent="flex-end">
            {[...Array(5)].map((_, index) => {
              return (
                <AttachMoney
                  key={index}
                  sx={{ fontSize: 17 }}
                  color={index < spot.lifeCost ? "primary" : "disabled"}
                ></AttachMoney>
              );
            })}
          </Grid>
        </Tooltip>
        <Grid item marginTop={-0.5} xs={12}>
          <Grid item container xs={12}>
            <Typography variant="h5" align="left">
              {spot.name}
            </Typography>
          </Grid>
          <Grid item container justifyContent="space-between" xs={12}>
            <Typography variant="h7" gutterBottom>
              {spot.country}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SpotCard;
